const booksData = [
  {
    "name": "freyid",
    "title": "Психология масс и анализ человеческого Я",
    "description": "«Психология масс и анализ человеческого Я» – один из известнейших трудов Зигмунда Фрейда – считается также одним из парадоксальнейших его произведений. Ведь здесь «отец психоанализа» выступает не столько как психоаналитик, сколько как классический психолог, исследующий не столько личностные, сколько социальные аспекты развития внутреннего мира человека и скрытых, глубинных мотивов формирования его мироощущения.",
    "author": "Зигмунд Фрейд",
    "category": "Психология",
    "url": "/pdfs/psyhology/freyid.pdf",
    "isFavorite": false
  },
  {
    "name": "dominanta",
    "title": "Доминанта",
    "description": "Алексей Алексеевич Ухтомский (1875–1942) – один из самых выдающихся отечественных мыслителей ХХ века. Его учение о доминанте как универсальном общебиологическом принципе, лежащем в основе активности всех живых систем, предвосхитило целый ряд направлений современных исследований и продолжает привлекать пристальное внимание специалистов различных областей знания. Теория доминанты позволяет изучать не только физиологические, но и психологические и социальные процессы. По сути дела, Ухтомский создал стройную концепцию человека на стыке различных наук: физиологии, психологии, философии, социологии и этики.",
    "author": "Алексей Алексеевич Ухтомский",
    "category": "Психология",
    "url": "/pdfs/psyhology/dominanta.pdf",
    "isFavorite": false
  },
  {
    "name": "fenomenyi_mozga",
    "title": "Феномены мозга",
    "description": "В этот сборник вошли психологические и психиатрические работы В. М. Бехтерева, посвященные вопросам гипноза, внушения и психологии масс, телепатии. Он исследовал возникновение иллюзий и галлюцинаций, проанализировал, почему случаются эпидемии религиозного характера и от чего на телах истово верующих появляются стигматы, объяснил феномен таких лидеров, как Жанна д’Арк, Магомет, Петр Великий, Наполеон, и почему за ними шли толпы, зараженные «психическим микробом».",
    "author": "Владимир Бехтерев",
    "category": "Медицина",
    "url": "/pdfs/medic/fenomenyi_mozga.pdf",
    "isFavorite": false
  },
  {
    "name": "defekt_i_sverhkompensaciya",
    "title": "Дефект и сверхкомпенсация",
    "description": "«В тех системах психологии, которые в центр ставят понятие целостной личности, идея сверхкомпенсации играет доминирующую роль. «Что меня не губит, делает меня сильнее», – формулирует эту идею В. Штерн, указывая, что из слабости возникает сила, из недостатков – способности (W. Stern, 1923. С. 145). Широко распространенное и очень влиятельное в Европе и Америке психологическое направление, созданное школой австрийского психиатра Адлера и называющее себя индивидуальной психологией, т. е. психологией личности, развило эту идею в целую систему, в законченное учение о психике. Сверхкомпенсация не есть какое-либо редкое или исключительное явление в жизни организма…»",
    "author": "Лев Семенович Выготский",
    "category": "Психология",
    "url": "/pdfs/psyhology/defekt_i_sverhkompensaciya.pdf",
    "isFavorite": false
  },
  {
    "name": "vyirojdenii",
    "title": "О вырождении рода человеческого",
    "description": "«Один из основных законов палеонтологии состоит в том, что породы животных тем геологически долговечнее, чем строение их проще, т. е. чем ниже стоят они на зоологической лестнице. Напротив, организмы сложные, требующие для своего существования на земле особенно выгодных и часто разнородных условий, обыкновенно живут не подолгу, а, быстро развившись в данную геологическую эпоху, столь же быстро исчезают в последующую…»",
    "author": "Михаил Венюков",
    "category": "Наука",
    "url": "/pdfs/science/vyirojdenii.pdf",
    "isFavorite": false
  },
  {
    "name": "kapital_tom_1",
    "title": "Капитал 1 том",
    "description": "Карл Маркс – философ, социолог, экономист и общественный деятель. Труды Карла Маркса, главный из которых «Капитал», сформировали в философии диалектический и исторический материализм, в экономике теорию прибавочной стоимости, в политике – теорию классовой борьбы. Благодаря «Капиталу» возникла идейная платформа социалистического и коммунистического движения, возникло само понятие «марксизм». Без преувеличения можно смело утверждать, что Карл Маркс повернул экономическую эволюцию цивилизации, стал идеологом революций – массовых, кровопролитных, братоубийственных. Впервые в нашей цивилизации философ смог так повлиять на историю развития человечества.",
    "author": "Карл Генрих Маркс",
    "category": "Экономика",
    "url": "/pdfs/economic/kapital_tom_1.pdf",
    "isFavorite": false
  },
  {
    "name": "kapital_tom_2",
    "title": "Капитал 2 том",
    "description": "Карл Маркс – философ, социолог, экономист и общественный деятель. Труды Карла Маркса, главный из которых «Капитал», сформировали в философии диалектический и исторический материализм, в экономике теорию прибавочной стоимости, в политике – теорию классовой борьбы. Благодаря «Капиталу» возникла идейная платформа социалистического и коммунистического движения, возникло само понятие «марксизм». Без преувеличения можно смело утверждать, что Карл Маркс повернул экономическую эволюцию цивилизации, стал идеологом революций – массовых, кровопролитных, братоубийственных. Впервые в нашей цивилизации философ смог так повлиять на историю развития человечества.",
    "author": "Карл Генрих Маркс",
    "category": "Экономика",
    "url": "/pdfs/economic/kapital_tom_2.pdf",
    "isFavorite": false
  },
  {
    "name": "kapital_tom_3",
    "title": "Капитал 3 том",
    "description": "Карл Маркс – философ, социолог, экономист и общественный деятель. Труды Карла Маркса, главный из которых «Капитал», сформировали в философии диалектический и исторический материализм, в экономике теорию прибавочной стоимости, в политике – теорию классовой борьбы. Благодаря «Капиталу» возникла идейная платформа социалистического и коммунистического движения, возникло само понятие «марксизм». Без преувеличения можно смело утверждать, что Карл Маркс повернул экономическую эволюцию цивилизации, стал идеологом революций – массовых, кровопролитных, братоубийственных. Впервые в нашей цивилизации философ смог так повлиять на историю развития человечества.",
    "author": "Карл Генрих Маркс",
    "category": "Экономика",
    "url": "/pdfs/economic/kapital_tom_3.pdf",
    "isFavorite": false
  },
  {
    "name": "сosmic_philosophy",
    "title": "Космическая философия",
    "description": "Космическая философия Циолковского – это новое осмысление Вселенной, завязанное на необходимости понимать и принимать изменения, происходящие с нашей планетой.",
    "author":  "Константин Циолковский",
    "category": "Наука",
    "url": "/pdfs/science/сosmic_philosophy.pdf",
    "isFavorite": false
  },
  {
    "name": "gryozy_o_zemle_i_nebe",
    "title": "Грёзы о Земле и небе",
    "description": "Богатство Вселенной неизмеримо… Каждый, кто хоть раз поднимал глаза к звездному небу, в этом убедится.",
    "author": "Константин Циолковский",
    "category": "Наука",
    "url": "/pdfs/science/gryozy_o_zemle_i_nebe.pdf",
    "isFavorite": false
  },
  {
    "name": "a_genius_among_men",
    "title": "Гений среди людей",
    "description": "Человек освоил множество различных профессий, но так и не нашел ответа на вопрос о существовании внеземных цивилизаций во Вселенной…",
    "author": "Константин Циолковский",
    "category": "Наука",
    "url": "/pdfs/science/a_genius_among_men.pdf",
    "isFavorite": false
  },
  {
    "name": "rukovodstvo_dlya_kozhevnika",
    "title": "Руководство для кожевника",
    "description": "Кожа предлагает почти безграничные горизонты... приятное хобби на всю жизнь... доходную карьеру, приносящую удовлетворение. Эта книга задумана быть некой розеткой, куда вы направляете свою креативную энергию и силы. На ее страницах вы найдете иллюстрированные пошаговые инструкции по выкройке и декорированию кожи, полезные подсказки, как держать и использовать различные инструменты, нужные для работы, плюс ко всему, - все, что нужно для правильно спланированной работы с кожей.",
    "author": "Штольман А., Паттен А.Д., Вильсон Дж.А.",
    "category": "Обучение",
    "url": "/pdfs/teach/rukovodstvo_dlya_kozhevnikan.pdf",
    "isFavorite": false
  },
  {
    "name": "poltava",
    "title": "Полтава",
    "description": "Мощь и слава войны, Как и люди, их суетные поклонники, Перешли на сторону торжествующего царя.",
    "author": "Пушкин А.С. ",
    "category": "Мировая литература",
    "url": "/pdfs/education/poltava.pdf",
    "isFavorite": false
  },
  {
    "name": "pesnya_pro_cary",
    "title": "Песня про царя Ивана Васильевича",
    "description": "Песня про царя Ивана Васильевича, молодого опричника и удалого купца Калашникова",
    "author": "Лермонтов М.Ю. ",
    "category": "Мировая литература",
    "url": "/pdfs/education/pesnya_pro_cary.pdf",
    "isFavorite": false
  },
  {
    "name": "taras_bulba",
    "title": "Тарас Бульба",
    "description": "Историческая повесть Николая Гоголя, в которой описана история казацкого восстания 1637–1638 годов, подавленного польскими войсками. ",
    "author": "Н.В. Гоголь ",
    "category": "Мировая литература",
    "url": "/pdfs/education/taras_bulba.pdf",
    "isFavorite": false
  },
  {
    "name": "zapici_ohotnika",
    "title": "Записки охотника",
    "description": "Противопоставление практичности и поэтичности в русском характере, а также изображение крестьян как сложных, многогранных личностей.",
    "author": "И.С. Тургенев ",
    "category": "Мировая литература",
    "url": "/pdfs/education/zapici_ohotnika.pdf",
    "isFavorite": false
  },
  {
    "name": "posle_bala",
    "title": "После бала",
    "description": "Происходит спор о том, что определяет человеческую судьбу. Присутствующий Иван Васильевич, пользующийся всеобщим авторитетом, неожиданно утверждает, что всё определяет банальный случай, и в подтверждение своих слов рассказывает историю, случившуюся с ним. ",
    "author": "Л.Н. Толстой ",
    "category": "Мировая литература",
    "url": "/pdfs/education/posle_bala.pdf",
    "isFavorite": false
  },
  {
    "name": "nekrasov",
    "title": "Стихотворения",
    "description": "Неиссякающая сила поэта Н. А. Некрасова — в особой доверительности его художественных интонаций: они обращены к сокровенным сторонам человеческой натуры, угнетаемой повседневностью, испытываемой на прочность социальными конфликтами.",
    "author": "Н.А Некрасов ",
    "category": "Мировая литература",
    "url": "/pdfs/education/nekrasov.pdf",
    "isFavorite": false
  },
  {
    "name": "saltykov_shedrin",
    "title": "Сказки",
    "description": "В иносказательной форме автор представляет читателям российскую действительность второй половины XIX века. С помощью аллегорических персонажей писатель обличает человеческие пороки, стремясь научить людей смотреть на себя со стороны.",
    "author": "М.Е. Салтыков ",
    "category": "Мировая литература",
    "url": "/pdfs/education/saltykov_shedrin.pdf",
    "isFavorite": false
  },
  {
    "name": "vasiliy_shibanov",
    "title": "Василий Шибанов",
    "description": "Человек и государство, верность человека своему долгу, нравственная красота человека из народа",
    "author": "А.К. Толстой ",
    "category": "Мировая литература",
    "url": "/pdfs/education/vasiliy_shibanov.pdf",
    "isFavorite": false
  },
  {
    "name": "knaz_mihailo_repnin",
    "title": "Князь Михайло Репнин",
    "description": "Иван Грозный на пиру убивает верного слугу",
    "author": "А.К. Толстой ",
    "category": "Мировая литература",
    "url": "/pdfs/education/knaz_mihailo_repnin.pdf",
    "isFavorite": false
  },
  {
    "name": "kust_sireni",
    "title": "Куст Сирени",
    "description": "Любовь — великая, созидающая сила, способная преодолеть любые невзгоды",
    "author": "А.И. Куприн ",
    "category": "Мировая литература",
    "url": "/pdfs/education/kust_sireni.pdf",
    "isFavorite": false
  },
  {
    "name": "last_from_mogikan",
    "title": "Последний из могикан",
    "description": "1757 год, в Европе бушует Семилетняя война, которая добралась и до американских колоний. Власти обеих враждующих держав — и Англии, и Франции — используют в боевых действиях обманутых или подкупленных индейцев, проживающих на их территориях. Один из союзников французов, подлый и мстительный гурон Магуа, похищает двух дочерей английского полковника Мунро — отважную Кору и нежную юную Алису.",
    "author": "Джеймс Фенимор Купер",
    "category": "Мировая литература",
    "url": "/pdfs/education/last_from_mogikan.pdf",
    "isFavorite": false
  },
  {
    "name": "zloumyishlennik",
    "title": "Злоумышленник ",
    "description": "Каждый человек должен отвечать за свои поступки, и незнание законов не освобождает от ответственности",
    "author": "А.П. Чехов",
    "category": "Мировая литература",
    "url": "/pdfs/education/zloumyishlennik.pdf",
    "isFavorite": false
  },
  {
    "name": "chehov_toska",
    "title": "Тоска ",
    "description": "Рассказ поднимает темы одиночества, отчуждения и человеческого равнодушия. Главный герой переживает глубокую личную трагедию — смерть сына, однако его страдания остаются незамеченными окружающими, а попытки поделиться с ними своей болью — тщетными",
    "author": "А.П. Чехов",
    "category": "Мировая литература",
    "url": "/pdfs/education/chehov_toska.pdf",
    "isFavorite": false
  },
  {
    "name": "staruha_Izergil",
    "title": "Старуха Изергиль ",
    "description": "То, в каком порядке автор расставил три истории, говорит о том, чью жизнь писатель считает наиболее достойной, а чью — совершенно лишённой смысла",
    "author": "М. Горкий",
    "category": "Мировая литература",
    "url": "/pdfs/education/staruha_Izergil.pdf",
    "isFavorite": false
  },
  {
    "name": "сhelkash",
    "title": "Челкаш ",
    "description": "История о жизни низших слоёв общества, о том, как непросто выживать в жёстких условиях. Это история о том, как люди, сталкивающиеся с нищетой и лишениями, вынуждены бороться за выживание и за свои права.",
    "author": "М. Горкий",
    "category": "Мировая литература",
    "url": "/pdfs/education/сhelkash.pdf",
    "isFavorite": false
  },
  {
    "name": "life_and_collar",
    "title": "Жизнь и воротник ",
    "description": "Внешние изменения и материальные вещи не должны определять нашу сущность и поведение. Рассказ подчёркивает важность сохранять свою индивидуальность и моральные принципы, не поддаваясь влиянию моды и общественных ожиданий",
    "author": "Н. Тэффи",
    "category": "Мировая литература",
    "url": "/pdfs/education/life_and_collar.pdf",
    "isFavorite": false
  },
  {
    "name": "dary_volhvov",
    "title": "Дары волхвов ",
    "description": "Рассказ о молодой семейной паре, которая накануне Рождества обнаруживает, что у них не хватает денег на праздничные подарки друг другу",
    "author": "О. Генри",
    "category": "Мировая литература",
    "url": "/pdfs/education/dary_volhvov.pdf",
    "isFavorite": false
  },
  {
    "name": "odisseya_cpt_blada",
    "title": "Одиссея капитана Блада ",
    "description": "Приключенческий роман о благородном разбойнике, волей судьбы оказавшемся вне закона, но не утратившем понятий о добре, чести и справедливости.",
    "author": "Р. Сабатинни",
    "category": "Мировая литература",
    "url": "/pdfs/education/odisseya_cpt_blada.pdf",
    "isFavorite": false
  },
  {
    "name": "matteo",
    "title": "Маттео Фальконе ",
    "description": "Предательство недопустимо ни при каких обстоятельствах, и нарушение моральных ценностей может привести к серьёзным последствиям",
    "author": "П. Мериме",
    "category": "Мировая литература",
    "url": "/pdfs/education/matteo.pdf",
    "isFavorite": false
  },
  {
    "name": "don_kihot",
    "title": "Хитроумный идальго Дон Кихот Ламанчский ",
    "description": "О приключениях мелкого дворянина Алонсо Кехана, который, начитавшись рыцарских романов, вообразил себя средневековым рыцарем. Он берёт себе рыцарское имя Дон Кихот, выбирает даму сердца Дульсинею из Тобосса, облачается в рыцарские доспехи, седлает старого коня Росинанта и вместе со своим оруженосцем — пастухом Санчо Панса — отправляется на поиски настоящих рыцарских приключений.",
    "author": "М. Серванес ",
    "category": "Мировая литература",
    "url": "/pdfs/education/don_kihot.pdf",
    "isFavorite": false
  },
  {
    "name": "abramov_o-chem-plachut",
    "title": "О чем плачут лошади ",
    "description": "Забота о природе, в частности о животных, автор пишет о лошадях: раньше в деревнях лошадь была огромной ценностью, а сейчас с коллективизацией лошадь стала не «другом семьи», а инструментом.  ",
    "author": "Ф.А. Абрамов",
    "category": "Мировая литература",
    "url": "/pdfs/education/abramov_o-chem-plachut.pdf",
    "isFavorite": false
  },
  {
    "name": "schukshin",
    "title": "Полное собрание ",
    "description": "Шукшин проявил себя как прозаик, драматург, сценарист и актер, и полное собрание демонстрирует все грани его творчества. ",
    "author": "В.М. Шукшин",
    "category": "Мировая литература",
    "url": "/pdfs/education/schukshin.pdf",
    "isFavorite": false
  },
  {
    "name": "platonov_ushka",
    "title": "Юшка ",
    "description": "Сила человека заключается не в физической мощи или грубых словах, а в добром и милосердном характере. История Юшки напоминает о важности сострадания и о том, что настоящая ценность человека измеряется его добрыми делами и бескорыстной любовью к другим",
    "author": "А. Платонов",
    "category": "Мировая литература",
    "url": "/pdfs/education/platonov_ushka.pdf",
    "isFavorite": false
  },
  {
    "name": "neizvestniy_cvetok",
    "title": "Неизвестный цветок",
    "description": "На пустыре среди камней вырастает одинокий красивый цветок. Ночью он собирает на своих листьях росу, а днём ловит принесённые ветром частички земли — это его пища. Трудно было цветку, но он хотел жить и превозмогал терпением «свою боль от голода и усталости»",
    "author": "А. Платонов",
    "category": "Мировая литература",
    "url": "/pdfs/education/neizvestniy_cvetok.pdf",
    "isFavorite": false
  },
  {
    "name": "mikhail-sholohov-rodinka",
    "title": "Родинка ",
    "description": "Рассказ описывает трагедию Гражданской войны, где отец и сын, оказавшиеся по разные стороны баррикад, погибают в братоубийственной войне, а единственным связующим звеном между ними остаётся родинка на ноге.",
    "author": "М.А. Шолохов",
    "category": "Мировая литература",
    "url": "/pdfs/education/mikhail-sholohov-rodinka.pdf",
    "isFavorite": false
  },
  {
    "name": "chuzhay_krov",
    "title": "Чужая кровь ",
    "description": "Рассказ о пожилых казаках, потерявших сына в Гражданской войне, и о том, как они принимают в свой дом и сердце раненого красноармейца, заменяя им погибшего сына",
    "author": "М.А. Шолохов",
    "category": "Мировая литература",
    "url": "/pdfs/education/chuzhay_krov.pdf",
    "isFavorite": false
  },
  {
    "name": "dorogi_kotorii_mi_vibiraem",
    "title": "Дороги, которые мы выбираем ",
    "description": "Это рассказ О. Генри, в котором раскрывается мысль о том, что выбор жизненного пути определяется не внешними обстоятельствами, а внутренними качествами человека",
    "author": "О. Генри ",
    "category": "Мировая литература",
    "url": "/pdfs/education/dorogi_kotorii_mi_vibiraem.pdf",
    "isFavorite": false
  },
  {
    "name": "zelenaya-lampa",
    "title": "Зеленая лампа ",
    "description": "Молодой человек, оказавшийся в трудной жизненной ситуации, получает шанс изменить свою судьбу благодаря случайному предложению миллионера, который просит его лишь зажигать зеленую лампу в окне. Символом надежды и стремления к лучшему становится зеленая лампа, помогающая герою осуществить мечту",
    "author": "А. Грин ",
    "category": "Мировая литература",
    "url": "/pdfs/education/zelenaya-lampa.pdf",
    "isFavorite": false
  },
  {
    "name": "aliye_parusa",
    "title": "Алые паруса",
    "description": "Это романтическая история о вере в мечту и о чуде, которое может произойти, если в это верить",
    "author": "А. Грин ",
    "category": "Мировая литература",
    "url": "/pdfs/education/aliye_parusa.pdf",
    "isFavorite": false
  },
  {
    "name": "astafev_fotografiya-na",
    "title": "Фотография, на которой меня нет",
    "description": "Повествует о мальчике Вите, который из-за болезни не попал на школьную фотографию и очень переживал из-за этого. В рассказе раскрывается тема ценности памяти, связи поколений и влияния прошлого на настоящее. ",
    "author": "В.П. Астафьев ",
    "category": "Мировая литература",
    "url": "/pdfs/education/astafev_fotografiya-na.pdf",
    "isFavorite": false
  },
  {
    "name": "little_prince",
    "title": "Маленький принц",
    "description": "Это философская сказка-притча французского писателя Антуана де Сент-Экзюпери, рассказывающая о путешествиях маленького мальчика с далекой планеты по разным астероидам и на Землю",
    "author": "А. де Сент-Экзюпери ",
    "category": "Мировая литература",
    "url": "/pdfs/education/little_prince.pdf",
    "isFavorite": false
  }
]

export  default booksData
  